import api from "./API";

/**
 * Item Service
 * API service for managing inventory items (formerly medicines)
 */

 export const itemService = {
  /**
   * Get all items with optional filters and pagination
   * @param {Object} params - Query parameters (page, limit, search, category, itemType, etc.)
   * @returns {Promise} API response with items list
   */
  getItems: (params) => api.get("/items", { params }),

  /**
   * Get a single item by ID
   * @param {string} id - Item ID
   * @returns {Promise} API response with item details
   */
  getItem: (id) => api.get(`/items/${id}`),

  /**
   * Create a new item
   * @param {Object} data - Item data
   * @returns {Promise} API response with created item
   */
  createItem: (data) => api.post("/items", data),

  /**
   * Update an existing item
   * @param {string} id - Item ID
   * @param {Object} data - Updated item data
   * @returns {Promise} API response with updated item
   */
  updateItem: (id, data) => api.put(`/items/${id}`, data),

  /**
   * Delete an item (soft delete)
   * @param {string} id - Item ID
   * @returns {Promise} API response
   */
  deleteItem: (id) => api.delete(`/items/${id}`),

  /**
   * Search items by text query
   * @param {string} query - Search query
   * @param {Object} params - Additional query parameters
   * @returns {Promise} API response with matching items
   */
  searchItems: (query, params = {}) => 
    api.get("/items/search", { params: { q: query, ...params } }),

  /**
   * Get stock details for a specific item
   * @param {string} id - Item ID
   * @returns {Promise} API response with batch stock information
   */
  getItemStock: (id) => api.get(`/items/${id}/stock`),

  /**
   * Generate barcode for an item
   * @param {string} id - Item ID
   * @returns {Promise} API response with barcode data
   */
  generateBarcode: (id) => api.post(`/items/${id}/barcode`),

  /**
   * Get stock history for an item
   * @param {string} id - Item ID
   * @param {Object} params - Query parameters (startDate, endDate, etc.)
   * @returns {Promise} API response with stock history
   */
  getStockHistory: (id, params) => 
    api.get(`/items/${id}/stock-history`, { params }),

  /**
   * Get batches for a specific item
   * @param {string} id - Item ID
   * @returns {Promise} API response with batch information
   */
  getBatches: (id) => api.get(`/items/${id}/batches`),

  /**
   * Get items by supplier
   * @param {string} supplierId - Supplier ID
   * @param {Object} params - Query parameters
   * @returns {Promise} API response with items from supplier
   */
  getBySupplier: (supplierId, params = {}) => 
    api.get(`/items/supplier/${supplierId}`, { params }),
};

export default itemService;
